/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import App from './App';

export class LazyLoad {
  constructor(element, options) {
    this.options = {
      selector: [{ view: 1, selector: 'data-src' }, { view: 2, selector: 'data-src-tablet' }, { view: 3, selector: 'data-src-desktop' }, { view: 4, selector: 'data-src-desktop' }, { view: 5, selector: 'data-src-desktop' }],
      threshold: 0.01,
      ...options,
    };
    this.element = element;
    this.resources = this.element.querySelectorAll('[data-src]');

    this.bindEvents();
    this.init();
  }

  bindEvents() {
    this._lazyLoadAsset = this._lazyLoadAsset.bind(this);
  }

  init() {
    const assetsOb = new IntersectionObserver((entries, assetsObserver) => {
      entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
        this._lazyLoadAsset(entry.target);
        assetsObserver.unobserve(entry.target);
      });
    }, this.options);
    this.resources.forEach((resource) => {
      assetsOb.observe(resource);
    });
  }

  _lazyLoadAsset(asset) {
    const data = this.options.selector.find((obj) => obj.view === App.vars.view);
    const src = asset.getAttribute(data.selector);
    if (!src) {
      return;
    }
    asset.onload = () => {
      asset.parentNode.classList.add('--loaded');
    };
    asset.src = src;
  }
}
